<template>
    <section id="home" :key="countToForceRefreshOnGoodiesUpdate">
      <!-- --------- Welcome infos --------- -->
      <h2>{{ $t("home.welcome_title") }}</h2>

      <!-- --------- Trending goodies --------- -->
      <div class="simpleBox" v-if="orderedGoodies() != null && orderedGoodies().length > 0">
        <h2 class="section_title">{{ $t("home.goodies_subtitle") }}</h2>
        <div class="contentList">
          <div v-for="goodie in orderedGoodies()" :key="'goodies_'+goodie['code']" class="content" v-bind:id="'goodies_'+goodie['code']+'_card'">
            <a :href="goodie['url']" target="_blank">
              <h3>
                <curve-text
                    :width="256"
                    :height="80"
                    :r="60"
                    class="curved_text"
                >
                  {{ goodie['name'] != null ? goodie['name'] : goodie['code'] }}
                </curve-text>
                <img
                  v-bind:src="goodie['image_url']"
                  height="256"
                  width="256"
                  v-bind:title="goodie['description']"
                />
              </h3>
            </a>
          </div>
        </div>
      </div>

      <!-- --------- Trending apps --------- -->
      <div class="simpleBox">
        <h2 class="section_title">{{ $t("home.apps_subtitle") }}</h2>
        <div class="contentList">
            <div v-for="app in apps.filter(app => jsonAppInfos[app]['is_trending'] == true)" :key="app" class="content" v-bind:id="app + '_card'">
            <router-link tag="h3" :to="$i18nRoute({ name: 'App', params: {selectedAppId: app}, hash:'#menu' })">
                <curve-text
                    :width="256"
                    :height="80"
                    :r="60"
                    class="curved_text"
                >
                {{ $t("apps." + app) }}
                </curve-text>
                <img
                v-bind:src="'images/apps/' + app + '.png'"
                v-bind:title="$t('apps.' + app)"
                />
            </router-link>
            </div>
        </div>

        <br />

        <!-- Button to go to 'FunnyLabz base Play Store page' -->
        <div class="external_store_button">
          <a
            href="https://play.google.com/store/apps/dev?id=7105242373770180771"
            target="_blank"
            v-bind:title="$t('apps.all_android')"
            id="button">
            <button class="blob-btn">
              <font-awesome-icon :icon="['fab', 'google-play']" class="btn_icon" size="lg" />{{
                $t("apps.all_android")
              }}
              <span class="blob-btn__inner">
                <span class="blob-btn__blobs">
                  <span class="blob-btn__blob"></span>
                  <span class="blob-btn__blob"></span>
                  <span class="blob-btn__blob"></span>
                  <span class="blob-btn__blob"></span>
                </span>
              </span>
            </button>
          </a>

          <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
            <defs>
              <filter id="goo">
                <feGaussianBlur
                  in="SourceGraphic"
                  result="blur"
                  stdDeviation="10"
                ></feGaussianBlur>
                <feColorMatrix
                  in="blur"
                  mode="matrix"
                  values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 21 -7"
                  result="goo"
                ></feColorMatrix>
                <feBlend in2="goo" in="SourceGraphic" result="mix"></feBlend>
              </filter>
            </defs>
          </svg>
        </div>
        <!-- Fin du code du bouton Play Store -->

        <!-- Button to go to 'FunnyLabz base Microsoft Store page' -->
        <div class="external_store_button">
          <a
            href="https://apps.microsoft.com/search/publisher?name=FunnyLabz"
            target="_blank"
            v-bind:title="$t('apps.all_windows')"
            id="button">
            <button class="blob-btn">
              <font-awesome-icon :icon="['fab', 'windows']" class="btn_icon" size="lg" />{{
                $t("apps.all_windows")
              }}
              <span class="blob-btn__inner">
                <span class="blob-btn__blobs">
                  <span class="blob-btn__blob"></span>
                  <span class="blob-btn__blob"></span>
                  <span class="blob-btn__blob"></span>
                  <span class="blob-btn__blob"></span>
                </span>
              </span>
            </button>
          </a>

          <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
            <defs>
              <filter id="goo">
                <feGaussianBlur
                  in="SourceGraphic"
                  result="blur"
                  stdDeviation="10"
                ></feGaussianBlur>
                <feColorMatrix
                  in="blur"
                  mode="matrix"
                  values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 21 -7"
                  result="goo"
                ></feColorMatrix>
                <feBlend in2="goo" in="SourceGraphic" result="mix"></feBlend>
              </filter>
            </defs>
          </svg>
        </div>
        <!-- Fin du code du bouton Microsoft Store -->
      </div>
    </section>
</template>

<script>
  import json_app_infos from "@/assets/json/app_infos.json";
  import CurveText from "@inotom/vue-curve-text";
  import { waitGoodiesInitialized, orderedGoodies } from '@/plugins/goodies.js'

  export default {
    components: { CurveText },
    name: "Home",
    data () {
      return {
        countToForceRefreshOnGoodiesUpdate: 0,
      }
    },
    computed: {
      apps() { return Object.keys(json_app_infos); },
      jsonAppInfos() { return json_app_infos; },
    },
    mounted() {
      this.refreshDataIfNeeded();
    },
    methods: {
      refreshDataIfNeeded() {
          waitGoodiesInitialized(false).then((isDataChanged) => {
            if (isDataChanged == true) {
              this.countToForceRefreshOnGoodiesUpdate++;
            }
          });
      },
      orderedGoodies() {
        this.refreshDataIfNeeded();
        return orderedGoodies('all', true);
      }
    },
    metaInfo() {
      return {
        title: this.$t('home.title')+' - FunnyLabz',
        description: this.$t('home.description'),
        keywords: this.$t('home.keywords'),
        lang: this.$i18n.locale,
      }
    },
  };
  </script>

  <style lang="scss" src="@/assets/styles/HomeView/main.scss" />
